var render = function render(){var _vm=this,_c=_vm._self._c;return _c('core-panel',{scopedSlots:_vm._u([{key:"head",fn:function(){return [_c('h1',[_vm._v("Locations")]),_c('p',[_vm._v("The locations most played at.")])]},proxy:true},{key:"body",fn:function(){return _vm._l((_vm.locations),function(item,index){return _c('app-thing',{key:index,attrs:{"nolink":true,"item":item,"dark":true}})})},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }